module.exports = __webpack_public_path__ + "img/shop.d76909a6.png";